export { PageContent as default } from "@/features/companyDetail/components/ArticleDetails/PageContent"
export { getServerSideArticleDetailsProps as getServerSideProps } from "@/features/companyDetail/server/getServerSideArticleDetailsProps"
